import file_doc from "@icons/file_doc.png";
import file_jpg from "@icons/file_jpg.png";
import file_mp4 from "@icons/file_mp4.png";
import file_other from "@icons/file_other.png";
import file_pdf from "@icons/file_pdf.png";
import file_png from "@icons/file_png.png";
import file_ppt from "@icons/file_ppt.png";
import file_xls from "@icons/file_xls.png";
import { GlobalFileData } from "../../../to-be-removed/LocalData/Files/GlobalFileData";
import { FileDocumentData } from "../../../to-be-removed/LocalData/General/FileDocumentData";
import { FirebaseFile } from "../../../to-be-removed/LocalData/General/FirebaseFile";

interface FileTypeImageViewProps {
  fileDocument?: FileDocumentData | GlobalFileData;
  fileType?: string | null;
  file?: File;
  firebaseFile?: FirebaseFile;
  className?: string;
  height?: string;
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
}
export const FileTypeImageView = (props: FileTypeImageViewProps) => {
  let fileType = props.fileDocument?.type ?? props.fileType ?? props.file?.name.split(".")[1] ?? props.firebaseFile?.title.split(".")[1] ?? "";
  if (fileType.includes("/")) {
    fileType = fileType.split("/")[1];
  }
  fileType = fileType.toLowerCase();
  const height = props.height ?? "100%";

  let src = file_other;
  if (["pdf"].includes(fileType)) src = file_pdf;
  if (["docx", "doc"].includes(fileType)) src = file_doc;
  if (["pptx", "ppt"].includes(fileType)) src = file_ppt;
  if (["xlsx", "xls", "xlsm", "xlsb"].includes(fileType)) src = file_xls;
  if (["jpg", "jpeg"].includes(fileType)) src = file_jpg;
  if (["png"].includes(fileType)) src = file_png;
  if (["mp3", "mp4"].includes(fileType)) src = file_mp4;

  return (
    <img
      src={src}
      alt={fileType}
      className={props.className}
      style={{
        height: height,
        marginRight: props.marginRight,
        marginBottom: props.marginBottom,
        marginLeft: props.marginLeft,
        marginTop: props.marginTop,
      }}
    />
  );
};
